import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Menu, MenuItem, IconButton, Box, Tooltip } from '@mui/material';
import { ReactComponent as MoreIcon } from '../../../../assets/images/more.svg';
import { ROUTES, getRouteWithParam } from '../../../../constants/routes';
import { activateTemplate, deleteTemplate } from '../../../../store/mailing/actions';
import { useDispatch } from 'react-redux';
import { DISABLED_CONTROL_TOOLTIP } from '../../../../constants/variables';

export const More = ({ id, status, setCurID, setIsSuccessModal, isEditableItem, isBackToWorkItem, isDeletableItem }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (e) => {
    e.preventDefault();
    setAnchorEl(e.currentTarget);
    setCurID(id);
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  const isArchivedStatus = status === 'Архив' || status === 'archive';

  const backToWork = () => {
    dispatch(activateTemplate(id));
  }
  const handleArchiver = () => {
    isArchivedStatus ? dispatch(deleteTemplate(id)) : setIsSuccessModal();
  }

  return (
    <>
      <Box>
        <IconButton onClick={handleClick}>
          <MoreIcon data-testid="MoreIcon"/>
        </IconButton>

        <Menu
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button'
          }}
        >
          { isArchivedStatus ? (
              isBackToWorkItem ? (
                <MenuItem
                  onClick={backToWork}
                  data-testid="BackToWork"
                >
                  Вернуть в работу
                </MenuItem>
              ) : (
                <Tooltip title={DISABLED_CONTROL_TOOLTIP} sx={{pointerEvents: 'auto'}} arrow>
                  <Box component="span">
                    <MenuItem disabled data-testid="BackToWork">
                      Вернуть в работу
                    </MenuItem>
                  </Box>
                </Tooltip>
                )
          ) : (
              isEditableItem ? (
                <MenuItem
                  component={RouterLink}
                  to={getRouteWithParam(ROUTES.MAILING_ADD_TEMPLATE, ':id', id)}
                  onClick={(e) => handleClose(e)}
                  data-testid="EditTemplate"
                >
                  Редактировать
                </MenuItem>
              ) : (
                <Tooltip title={DISABLED_CONTROL_TOOLTIP} sx={{pointerEvents: 'auto'}} arrow>
                  <Box component="span">
                    <MenuItem disabled data-testid="EditTemplateDisabled">
                      Редактировать
                    </MenuItem>
                  </Box>
                </Tooltip>
              )
            )
          }

          { isArchivedStatus ? (
            isDeletableItem ? (
              <MenuItem
                onClick={(e) => {
                  handleClose(e);
                  handleArchiver();
                }}
                sx={{ color: 'error.main' }}
                data-testid="DeleteTemplate"
              >
                Удалить
              </MenuItem>
            ) : (
              <Tooltip title={DISABLED_CONTROL_TOOLTIP} sx={{pointerEvents: 'auto'}} arrow>
                <Box component="span">
                  <MenuItem sx={{ color: 'error.main' }} disabled data-testid="DeleteTemplate">
                    Удалить
                  </MenuItem>
                </Box>
              </Tooltip>
              )
          ) : (
            isBackToWorkItem ? (
              <MenuItem
                onClick={(e) => {
                  handleClose(e);
                  handleArchiver();
                }}
                sx={{ color: 'error.main' }}
                data-testid="ArchiveTemplate"
              >
                В архив
              </MenuItem>
            ) : (
              <Tooltip title={DISABLED_CONTROL_TOOLTIP} sx={{pointerEvents: 'auto'}} arrow>
                <Box component="span">
                  <MenuItem disabled data-testid="ArchiveTemplateDisabled">
                    В архив
                  </MenuItem>
                </Box>
              </Tooltip>
            )
          )
        }
        </Menu>
      </Box>
    </>
  );
};

More.propTypes = {
  id: PropTypes.any,
  status: PropTypes.string,
  setCurID: PropTypes.func,
  setIsSuccessModal: PropTypes.func,
  isEditableItem: PropTypes.bool,
  isBackToWorkItem: PropTypes.bool,
  isDeletableItem: PropTypes.bool,
};
